import React, { createContext, useContext, useMemo } from 'react';
import { GlobalKeys, useLocalStorage } from 'helpers/localStorage';

export interface ISideNavCollapsedContextValue {
    isCollapsed: boolean;
    setCollapsed: (next: boolean) => void;
    toggle: () => void;
}

const SideNavCollapsedContext = createContext<ISideNavCollapsedContextValue | null>(null);

export const SideNavCollapsedProvider = ({ children }: { children: React.ReactNode }) => {
    const [isCollapsed, setIsCollapsed] = useLocalStorage<boolean>(
        GlobalKeys.NavbarV2Collapsed,
        false,
        { crossDomain: true },
    );

    const value = useMemo<ISideNavCollapsedContextValue>(() => ({
        isCollapsed,
        setCollapsed: (next: boolean) => setIsCollapsed(next),
        toggle: () => setIsCollapsed(prev => !prev),
    }), [isCollapsed, setIsCollapsed]);

    return (
        <SideNavCollapsedContext.Provider value={value}>
            {children}
        </SideNavCollapsedContext.Provider>
    );
};

const useSideNavCollapsed = (): ISideNavCollapsedContextValue => {
    const context = useContext(SideNavCollapsedContext);
    if (!context) {
        return { isCollapsed: false, setCollapsed: () => {}, toggle: () => {} };
    }
    return context;
};

export default useSideNavCollapsed;
